export const viewExamples = {
  Recommended: [
    {
      description: 'Shipments running late by more than 3 days',
      label: 'Running late',
      tags: ['All Modes', 'Exceptions'],
      url: '/results?filters=(listView:all-shipments,viewType:shipment,filter.text.milestones:(filter.milestones.arrival),filter.milestones.arrival:((filter.milestones.estimatedTime,filter.operators.isLateBy,(!3,!1440)),(filter.milestones.stopType,filter.operators.is,(DESTINATION))))',
    },
    {
      description:
        'Ocean containers departed late at port of loading by more than 3 days',
      label: 'Late departure containers',
      tags: ['Ocean', 'Exceptions'],
      url: '/results?filters=(listView:all-shipments,viewType:shipment,filter.text.milestones:(filter.milestones.departure),filter.milestones.departure:((filter.milestones.actualTime,filter.operators.isLateBy,(!3,!1440)),(filter.milestones.stopType,filter.operators.is,(PORT_OF_LOADING))),filter.text.modeOfShipment:(filter.modeOfShipment.ocean))',
    },
    {
      description:
        'Ocean containers discharging late at port of discharge by more than 3 days',
      label: 'Late discharge containers',
      url: '/results?filters=(listView:all-shipments,viewType:shipment,filter.text.milestones:(filter.milestones.discharge),filter.text.modeOfShipment:(filter.modeOfShipment.ocean),filter.milestones.discharge:((filter.milestones.estimatedTime,filter.operators.isLateBy,(!3,!1440)),(filter.milestones.stopType,filter.operators.is,(PORT_OF_DISCHARGE))))',
      tags: ['Ocean', 'Exceptions'],
    },
    {
      description: 'Rail shipments running early by more than 3 days',
      label: 'Rail running early',
      tags: ['Rail'],
      url: '/results?filters=(listView:all-shipments,viewType:shipment,filter.text.milestones:(filter.milestones.arrival),filter.text.modeOfShipment:(filter.modeOfShipment.rail),filter.milestones.arrival:((filter.milestones.estimatedTime,filter.operators.isEarlyBy,(!3,!1440))))',
    },
  ],
  Exceptions: [
    {
      description:
        'Ocean containers departed late at port of loading by more than 3 days',
      label: 'Late departure containers',
      tags: ['Ocean', 'Exceptions'],
      url: '/results?filters=(listView:all-shipments,viewType:shipment,filter.text.milestones:(filter.milestones.departure),filter.milestones.departure:((filter.milestones.actualTime,filter.operators.isLateBy,(!3,!1440)),(filter.milestones.stopType,filter.operators.is,(PORT_OF_LOADING))),filter.text.modeOfShipment:(filter.modeOfShipment.ocean))',
    },
    {
      description:
        'Ocean containers discharging late at port of discharge by more than 3 days',
      label: 'Late discharge containers',
      url: '/results?filters=(listView:all-shipments,viewType:shipment,filter.text.milestones:(filter.milestones.discharge),filter.text.modeOfShipment:(filter.modeOfShipment.ocean),filter.milestones.discharge:((filter.milestones.estimatedTime,filter.operators.isLateBy,(!3,!1440)),(filter.milestones.stopType,filter.operators.is,(PORT_OF_DISCHARGE))))',
      tags: ['Ocean', 'Exceptions'],
    },
  ],
  Reporting: [
    {
      description: 'Ocean containers discharged in a transshipment port',
      label: 'Ocean containers at transshipment port',
      url: '/results?filters=(listView:all-shipments,viewType:shipment,filter.text.modeOfShipment:(filter.modeOfShipment.ocean),filter.text.routes:(filter.routes.currentStop),filter.routes.currentStop:((filter.routes.stopType,filter.operators.is,(TRANSSHIPMENT_PORT))))',
      tags: ['Ocean', 'Exceptions'],
    },
  ],
  Ocean: [
    {
      description:
        'Ocean containers departed late at port of loading by more than 3 days',
      label: 'Late departure containers',
      tags: ['Ocean', 'Exceptions'],
      url: '/results?filters=(listView:all-shipments,viewType:shipment,filter.text.milestones:(filter.milestones.departure),filter.milestones.departure:((filter.milestones.actualTime,filter.operators.isLateBy,(!3,!1440)),(filter.milestones.stopType,filter.operators.is,(PORT_OF_LOADING))),filter.text.modeOfShipment:(filter.modeOfShipment.ocean))',
    },
    {
      description:
        'Ocean containers discharging late at port of discharge by more than 3 days',
      label: 'Late discharge containers',
      tags: ['Ocean', 'Exceptions'],
      url: '/results?filters=(listView:all-shipments,viewType:shipment,filter.text.milestones:(filter.milestones.discharge),filter.text.modeOfShipment:(filter.modeOfShipment.ocean),filter.milestones.discharge:((filter.milestones.estimatedTime,filter.operators.isLateBy,(!3,!1440)),(filter.milestones.stopType,filter.operators.is,(PORT_OF_DISCHARGE))))',
    },
    {
      description: 'Ocean shipments running late by more than 7 days',
      label: 'Late ocean shipments',
      tags: ['Ocean', 'Exceptions'],
      url: '/results?filters=(listView:all-shipments,viewType:shipment,filter.text.modeOfShipment:(filter.modeOfShipment.ocean),filter.text.milestones:(filter.milestones.arrival),filter.milestones.arrival:((filter.milestones.estimatedTime,filter.operators.isLateBy,(!7,!1440)),(filter.milestones.stopType,filter.operators.is,(PORT_OF_DISCHARGE))))',
    },
  ],
  Truckload: [
    {
      description: 'Truckload shipments running early by more than 3 days',
      label: 'Truckload running early',
      tags: ['TL'],
      url: '/results?filters=(listView:all-shipments,viewType:shipment,filter.text.milestones:(filter.milestones.arrival),filter.milestones.arrival:((filter.milestones.estimatedTime,filter.operators.isEarlyBy,(!3,!1440)),(filter.milestones.stopType,filter.operators.is,(DESTINATION))),filter.text.modeOfShipment:(filter.modeOfShipment.truckload))',
    },
    {
      description: 'Truckload shipments running late by more than 3 days',
      label: 'Truckload running late',
      tags: ['TL', 'Exceptions'],
      url: '/results?filters=(listView:all-shipments,viewType:shipment,filter.text.milestones:(filter.milestones.arrival),filter.milestones.arrival:((filter.milestones.estimatedTime,filter.operators.isLateBy,(!3,!1440)),(filter.milestones.stopType,filter.operators.is,(DESTINATION))),filter.text.modeOfShipment:(filter.modeOfShipment.truckload))',
    },
  ],
  Rail: [
    {
      description: 'Rail shipments running early by more than 3 days',
      label: 'Rail running early',
      tags: ['Rail'],
      url: '/results?filters=(listView:all-shipments,viewType:shipment,filter.text.milestones:(filter.milestones.arrival),filter.text.modeOfShipment:(filter.modeOfShipment.rail),filter.milestones.arrival:((filter.milestones.estimatedTime,filter.operators.isEarlyBy,(!3,!1440))))',
    },
    {
      description: 'Rail shipments running late by more than 3 days',
      label: 'Rail running late',
      tags: ['Rail', 'Exceptions'],
      url: '/results?filters=(listView:all-shipments,viewType:shipment,filter.text.milestones:(filter.milestones.arrival),filter.milestones.arrival:((filter.milestones.estimatedTime,filter.operators.isLateBy,(!3,!1440)),(filter.milestones.stopType,filter.operators.is,(DESTINATION))),filter.text.modeOfShipment:(filter.modeOfShipment.rail))',
    },
  ],
};
